<p class="mb-16">
  {{ "onboardingConsents.description" | fms }}
</p>

<div>
  <section class="mb-24">
    <div class="font-heading-4 mb-08">{{ "onboardingConsents.dataStorage.title" | fms }}</div>
    <p class="mt-0 mb-08">
      {{ "onboardingConsents.dataStorage.description" | fms }}
    </p>

    @if (storageRadioButtons$ | async; as storageRadioButtons) {
      <stb-radio-buttons
        [name]="'storageRadio'"
        [rebrand]="true"
        [horizontal]="true"
        [group]="storageRadioButtons"
        [message]="'onboardingConsents.dataStorage.error' | fms"
        [warning]="(storageConsentControl.statusChanges | async) === 'INVALID'"
        (valueChanged)="setStorageControl($event)"
        data-trackid="link-onboarding-dataStorage-radioButton"
      >
      </stb-radio-buttons>
    }
  </section>

  <section>
    <div class="font-heading-4">{{ "onboardingConsents.norskPensjon.title" | fms }}</div>
    <div class="mb-08 mt-0">
      @if (showFullText) {
        <div [innerHTML]="'onboardingConsents.norskPensjon.description.readMoreText' | fms"></div>
      } @else {
        <div [innerHTML]="'onboardingConsents.norskPensjon.description' | fms"></div>
      }
      <a (click)="showFullText = !showFullText">
        {{ showFullText ? ("show.less" | fms) : ("show.more" | fms) }}
      </a>
    </div>
    @if (norskPensjonRadioButtons$ | async; as norskPensjonRadioButtons) {
      <stb-radio-buttons
        [rebrand]="true"
        [name]="'norskPensjonRadio'"
        [horizontal]="true"
        [group]="norskPensjonRadioButtons"
        [message]="'onboardingConsents.norskPensjon.error' | fms"
        [warning]="(norskPensjonConsentControl.statusChanges | async) === 'INVALID'"
        (valueChanged)="setNorskPensjonControl($event)"
        data-trackid="link-onboarding-norskPensjon-radioButton"
      >
      </stb-radio-buttons>
    }
  </section>
</div>
